/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Defectp11Inputs */



/**
* | output |
* | --- |
* | "Left/top pump fault" |
*
* @param {Ahu_History_Key_Defectp11Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_defectp11 = /** @type {((inputs?: Ahu_History_Key_Defectp11Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Defectp11Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/top pump fault")
	return /** @type {LocalizedString} */ ("Défaut pompe gauche/haute")
});
export { ahu_history_key_defectp11 as "ahu_history_key_defectP1" }